import { render, staticRenderFns } from "./TncModal.vue?vue&type=template&id=105762e0&scoped=true"
import script from "./TncModal.vue?vue&type=script&lang=js"
export * from "./TncModal.vue?vue&type=script&lang=js"
import style0 from "./TncModal.vue?vue&type=style&index=0&id=105762e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105762e0",
  null
  
)

export default component.exports